module.exports = __webpack_public_path__ + "static/img/logo.1c8a57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 0